import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
// Import the API module early to ensure the fetch wrapper is loaded
import './lib/api'

async function enableMocking() {
  // Load and start the mock service worker regardless of environment
  const { worker } = await import('./mocks/browser')
  
  // Start the worker with specific options
  return worker.start({
    onUnhandledRequest: 'bypass', // Don't warn about unhandled requests
    waitUntilReady: true, // Ensure the worker is ready before proceeding
    serviceWorker: {
      url: '/mockServiceWorker.js',
      options: {
        scope: '/'
      }
    }
  })
}

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
})
